<template>
  <ConfirmationPopup
    ref="confirmationPopup"
    type="warning"
    :closeable="true"
    title="Увага!"
    message=""
    :controls="controls"
    :max-width="500"
    @close="onClose"
  >
    <p class="eia-warning__message">
      Платіж може бути перерахований після внесення ІПН страхувальника
    </p>
  </ConfirmationPopup>
</template>

<script>
import { ConfirmationPopup } from '@/shared/ui/popup';

export default {
  components: { ConfirmationPopup },
  computed: {
    controls() {
      return [{ type: 'default', label: 'Зрозуміло', event: 'close' }];
    },
  },
  methods: {
    open() {
      this.$refs.confirmationPopup.open();
    },
    close() {
      this.$refs.confirmationPopup?.close();
    },
    onClose() {
      this.$emit('closed');
    },
  },
};
</script>

<style scoped lang="scss">
.eia-warning {
  &__message {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  }
}
</style>